module.exports = __webpack_public_path__ + "img/shape_semicircle.589b8aa6.svg";